module.exports = __webpack_public_path__ + "static/media/2040318000.07989a91.jpg";